/* tslint:disable:typedef-whitespace align no-trailing-whitespace */

import { Action, ActionType    } from '@/models/action';
import { Logger                } from '@/util/logger';

/**
 *
 * @class HelpAddUserAction
 *
 * @brief register a new user
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class HelpAddUserAction extends Action {

  constructor(options: any = null) {

    super({
      key:   'help.register',
      type:  ActionType.Help_Register,
      label: 'Add User',
      icon:  '<i class="fas fa-user-plus"></i>',
      tip:   'Register a new user'
    });

  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[HelpAddUserAction] executing...');

    return true;
  }
}
